import React from "react";
import Tick from "./Tick";
import "./index.less";
import { Alert, Divider } from "antd";

interface XiZangConsolidateProps {
    orderOriginalId: string;
}

const XiZangConsolidate: React.FC<XiZangConsolidateProps> = function (props) {
    const { orderOriginalId } = props;

    return (
        <div
            className="p5 consolidate"
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <h2 className="fb">
                西藏中转订单 <span className="highlight">请直接发货至中转仓库</span>即可
                <small>
                    （详细信息请
                    <a href="https://mms.pinduoduo.com/daxue/detail?courseId=5202" target="_blank">
                        查看课程
                    </a>
                    ）
                </small>
            </h2>

            <div className="flex progress-item">
                <Tick />

                <div className="f1 ml10">
                    <h3 className="fb">中转流程</h3>
                    <div className="mt5 flex transfer-container" style={{ justifyContent: "space-between" }}>
                        <div className="transfer-item">
                            <img
                                src="https://img.alicdn.com/imgextra/i4/54458674/O1CN01rdBzNq2DwkFP17qMG_!!54458674.png"
                                alt=""
                                className="display-block"
                            />
                            <span>消费者下单</span>
                        </div>
                        <div className="transfer-item">
                            <img
                                src="https://img.alicdn.com/imgextra/i3/54458674/O1CN01hqkFCG2DwkFVDxtYF_!!54458674.png"
                                alt=""
                                className="display-block"
                            />
                            <span>商家发货</span>
                        </div>
                        <div className="transfer-item">
                            <img
                                src="https://img.alicdn.com/imgextra/i4/54458674/O1CN01rdBzNq2DwkFP17qMG_!!54458674.png"
                                alt=""
                                className="display-block"
                            />
                            <span>中转仓签收</span>
                        </div>
                        <div className="transfer-item">
                            <img
                                src="https://img.alicdn.com/imgextra/i3/54458674/O1CN01hqkFCG2DwkFVDxtYF_!!54458674.png"
                                alt=""
                                className="display-block"
                            />
                            <span>中转仓发货</span>
                        </div>
                        <div className="transfer-item">
                            <img
                                src="https://img.alicdn.com/imgextra/i4/54458674/O1CN01kFrfCf2DwkFS40hyy_!!54458674.png"
                                alt=""
                                className="display-block"
                            />
                            <span>消费者收货</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex progress-item">
                <Tick />

                <div className="f1 ml10">
                    <h3 className="fb">直接发货至中转仓库</h3>

                    <span className="text-gray">
                        订单收件人信息已替换为中转仓地址，打单发货时请
                        <span className="highlight">复制完整的收货信息(包括地址后识别码)</span>
                    </span>
                </div>
            </div>

            <div className="flex progress-item">
                <Tick />

                <div className="f1 ml10">
                    <h3 className="fb">中转仓库二次发货至消费者</h3>

                    <span className="text-gray">
                        中转仓凑齐消费者订单后重新打包，贴新运单，第二段直接发货至西藏消费者实际地址
                        <span className="highlight">（第二段物流由平台补贴承担）</span>
                    </span>
                </div>
            </div>

            <div className="flex progress-item">
                <Tick />

                <div className="f1 ml10">
                    <h3 className="fb">消费者信息 / 中转状态 / 二段轨迹信息查看请移步至商家后台</h3>

                    <span className="text-gray">
                        若您需要查看消费者信息/中转状态 / 最新二段物流轨迹，请前往拼多多商家后台
                        <a
                            href={`https://mms.pinduoduo.com/orders/detail?type=4399&sn=${orderOriginalId}`}
                            target="_blank"
                        >
                            查看订单
                        </a>
                    </span>
                </div>
            </div>

            <Divider style={{ margin: "5px" }}></Divider>

            <span className="text-light ml25">电话咨询请拨打（021）60683100</span>
        </div>
    );
};

export default React.memo(XiZangConsolidate);
